<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Inserisci le tue credenziali</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form>
              <v-text-field
                v-model="username"
                label="Utente"
                type="text"
                required
                autofocus
              />

              <v-text-field
                label="Password"
                v-model="password"
                v-on:keyup.enter="login"
                v-bind:error="unsuccessful"
                v-bind:error-messages="error"
                v-bind:append-icon="passwordVisible ? 'mdi-eye' : 'mdi-eye-off'"
                v-bind:type="passwordVisible ? 'text' : 'password'"
                v-on:click:append="passwordVisible = !passwordVisible"
                required
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              v-on:click="login"
              v-bind:loading="server_loading"
              class="primary"
            >Accedi</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import server from '../mixins/server';
import user from '../mixins/user';

export default {
  name: 'Login',

  mixins: [ server, user ],

  data: () => ({
    error: null,
    username: '',
    password: '',
    passwordVisible: false,
  }),

  computed: {
    unsuccessful: function() { return this.error != null; },
  },

  mounted () {
    // Logout current user when the component is loaded
    this.server_execute({ url: 'User/logout' });

    // Clear current user data
    this.user_reset();
  },

  methods: {
    login() {
      this.server_send({
        url: 'User/login',
        data: { username: this.username, password: this.password },
        onSuccess: (data) => {
          // Update user data and load default view
          this.error = null;

          // Clear local storage before logging in
          localStorage.clear();

          this.user_set(data);
          this.$router.push('/home');
        },
        onError: (error) => {
          // Check if we are sending bad user name or password
          if (error && error.status === 401) {
            this.error = 'Utente o password non validi';
            return true; // Error is handled
          }
        }
      });
    },
  }
};
</script>